"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectableItems = exports.itemToString = void 0;
exports.itemToString = function (item) {
    if ((item === null || item === void 0 ? void 0 : item.type) === "option" && item.label) {
        return item.label;
    }
    return "";
};
exports.getSelectableItems = function (selectItems) {
    return selectItems.filter(function (item) { return item.type === "option"; });
};
//# sourceMappingURL=utils.js.map